import { captureEvent } from '../metrics/captureEvent'

/**
 * Captures loaded event once the page has fully loaded. It doesn't wait for
 * gtag, so it still fires when GTM is blocked (ad blockers, cookie consent).
 *
 * @param {string} [event] - event name, for pages that report under their own
 */
export function captureLoaded(event = 'form-loaded') {
  const send = () => captureEvent(event)

  if (document.readyState === 'complete') {
    send()
    return
  }

  window.addEventListener('load', send, { once: true })
}
